/* HALE marketplace shared design tokens.
 *
 * Cream/ivory editorial palette — matches the live Hale Marketplace,
 * Hale Admin Hub, AG Reviewer console, and Hale Decisions console.
 * Brand intake reads from the same tokens so the founder journey
 * lives inside the same visual system as the rest of the platform.
 * The HALE red wordmark block stays as an accent for the wordmark and
 * primary CTAs only; the page surface itself is ivory/cream. */

// Surface tokens (ivory editorial canvas)
export const HALE_BG          = '#F5F1E8';                  // ivory canvas
export const HALE_BG_SOFT     = 'rgba(255,255,255,0.60)';   // raised card surface
export const HALE_BG_RAISED   = 'rgba(255,255,255,0.78)';   // pinned card surface

// Hairlines
export const HALE_HAIR        = 'rgba(11,20,38,0.10)';
export const HALE_HAIR_STRONG = 'rgba(11,20,38,0.18)';

// Ink + text
export const HALE_INK         = '#0B1426';                  // primary text · slate
export const HALE_TEXT        = '#0B1426';
export const HALE_TEXT_MUTED  = '#5B6577';                  // secondary text
export const HALE_TEXT_FAINT  = 'rgba(11,20,38,0.45)';      // tertiary text · captions

// Accents (preserved — HALE red wordmark + CTAs)
export const HALE_RED         = '#E63946';
export const HALE_RED_DEEP    = '#C9192C';
export const HALE_CHAMPAGNE   = '#A07A14';                  // gold accent for premium moments

/* Category & retailer dictionaries shown in the intake. Kept centralised so
 * the founder-facing copy stays consistent across screens. */
export const CATEGORIES = [
  { key: 'grooming',         label: 'Grooming' },
  { key: 'supplements',      label: 'Supplements & Performance' },
  { key: 'fragrance',        label: 'Fragrance' },
  { key: 'sexual_wellness',  label: 'Sexual Wellness' },
  { key: 'skincare',         label: 'Skincare & Personal Care' },
  { key: 'lifestyle',        label: 'Lifestyle & Recovery' },
  { key: 'haircare',         label: 'Haircare' },
];

export const RETAILERS = [
  { key: 'sephora',     label: 'Sephora' },
  { key: 'credo',       label: 'Credo' },
  { key: 'wholefoods',  label: 'Whole Foods' },
  { key: 'target',      label: 'Target Clean' },
  { key: 'ulta',        label: 'Ulta Conscious Beauty' },
  { key: 'nordstrom',   label: 'Nordstrom' },
  { key: 'amazon_lux',  label: 'Amazon Luxury Stores' },
  { key: 'specialty',   label: 'Independent specialty' },
];

export const PACKAGING_MATERIALS = [
  'Glass', 'Aluminum', 'PCR-PET', 'Bio-resin', 'Refill pouches',
  'Stainless steel', 'Compostable paper',
];

export const SUSTAINABILITY_DECLS = [
  { key: 'carbon_offset',       label: 'Carbon-offset operations' },
  { key: 'b_corp',              label: 'B-Corp certified' },
  { key: 'leaping_bunny',       label: 'Leaping Bunny' },
  { key: 'supply_chain_audit',  label: 'Audited supply chain' },
  { key: 'living_wage',         label: 'Living-wage commitments' },
  { key: 'cradle_to_cradle',    label: 'Cradle-to-cradle program' },
];

export const STANDARDS_NARRATIVE = {
  hale_reviewed: {
    name: 'HALE Reviewed™',
    short: 'Scientific governance · retailer readiness',
    blurb: 'Ingredient transparency, formula review, packaging governance overlays, '
         + 'and retailer-readiness documentation — assembled into a portable, '
         + 'reusable scientific governance layer for modern men\'s brands.',
  },
  hale_verified: {
    name: 'HALE Verified™',
    short: 'Documentation maturity · supplier interoperability',
    blurb: 'Supplier-supported documentation, packaging governance overlays, '
         + 'and sustainability interoperability — built around the documentation '
         + 'expectations modern retailers are converging on.',
  },
  both: {
    name: 'HALE Reviewed™ + HALE Verified™',
    short: 'Full governance infrastructure',
    blurb: 'The full scientific governance infrastructure stack — '
         + 'ingredient review, packaging governance, supplier documentation, '
         + 'and retailer-readiness portability. Built for portfolio operators.',
  },
};
